import IssueForbidden from "./components/IssueForbidden";

export default IssueForbidden;